<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="field-value">
      <ul
       v-if="publicFiles.length"
       class="list-disc list-inside ml-4"
      >
        <li
          v-for="file of publicFiles"
          :key="file.path"
          class="col col-12 mt-2"
        >
          <button
            type="button"
            :title="file.name"
            :aria-label="`Press to download ${file.name}`"
            @click="downloadFile(file)"
          >{{file.name}}</button>
        </li>
      </ul>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { assembleUrl } from '@/utils/url'

// TODO: move to .env
const PUBLIC_BUCKET = 'coursedog-static-public'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('settings', ['school']),
    publicFiles() {
      return this.value.length ? this.value.filter((file) => file.public) : []
    },
  },
  methods: {
    async downloadFile(file) {
      const fileParams = {
        fileName: file.path,
        type: 'get',
        originalName: file.name,
        bucketName: PUBLIC_BUCKET,
      }

      const fileUrl = await this.$axios.post(
        assembleUrl(`${this.school}/files/signedUrl`, fileParams)
      )
      window.open(fileUrl.data, '_blank')
    },
  },
}
</script>
